const memory = new Map();
let nativeDisabled = false;

function isAccessDenied(error) {
  return error?.name === 'SecurityError' || error?.code === 18;
}

function nativeStorage() {
  if (nativeDisabled || typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch (error) {
    if (isAccessDenied(error)) {
      nativeDisabled = true;
    }
    return null;
  }
}

export const safeLocalStorage = {
  getItem(key) {
    // A failed native write (quota, etc.) keeps the latest value only in memory
    // while the previous native value stays readable. Memory wins until a later
    // native write succeeds and drops the overlay.
    if (memory.has(key)) {
      return memory.get(key);
    }

    const native = nativeStorage();
    if (!native) {
      return null;
    }

    try {
      return native.getItem(key);
    } catch (error) {
      if (isAccessDenied(error)) {
        nativeDisabled = true;
      }
      return null;
    }
  },

  setItem(key, value) {
    const stored = String(value);
    const native = nativeStorage();
    if (native) {
      try {
        native.setItem(key, stored);
        memory.delete(key);
        return;
      } catch (error) {
        if (isAccessDenied(error)) {
          nativeDisabled = true;
        }
      }
    }

    memory.set(key, stored);
  },

  removeItem(key) {
    memory.delete(key);
    const native = nativeStorage();
    if (!native) {
      return;
    }

    try {
      native.removeItem(key);
    } catch (error) {
      if (isAccessDenied(error)) {
        nativeDisabled = true;
      }
    }
  },

  clear() {
    memory.clear();
    const native = nativeStorage();
    if (!native) {
      return;
    }

    try {
      native.clear();
    } catch (error) {
      if (isAccessDenied(error)) {
        nativeDisabled = true;
      }
    }
  },
};

export function resetSafeLocalStorageState() {
  nativeDisabled = false;
  memory.clear();
}
